import {AUTH_UPDATE_RETURN_URL} from './available'
export default {
  LOAD_ACCOUNT(state, user) {
    state.account = user
    state.isLogged = true
  },
  LOGOUT(state) {
    state.account = null
    state.isLogged = false
  },
  [AUTH_UPDATE_RETURN_URL](state, returnUrl) {
    state.auth.returnUrl = returnUrl
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/account.js